/**
 * Shared theme - colors and styles used across all forms
 */

// Brand colors
export const colors = {
  darkTeal: '#416E72',
  teal: '#5B979A',
  lightTeal: '#99CFCF',
  paleTeal: '#BFDBDB',
  lightestTeal: '#D9F0EE',
  nearBlack: '#181815',
  darkGray: '#353433',
  mediumGray: '#585752',
  lightGray: '#B5B4AE',
  lighterGray: '#E3E3DB',
  offWhite: '#F3F3F0',
  white: '#FFFFFF',
  darkGold: '#E0B004',
  gold: '#F0CC4C',
  paleGold: '#FFE898',
  error: '#c53030',
  errorLight: '#fed7d7',
};

// Common styles
export const sectionTitleStyle = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '600',
  fontSize: '18px',
  color: colors.darkTeal,
  marginBottom: '16px',
  paddingBottom: '8px',
  borderBottom: `2px solid ${colors.lightestTeal}`,
};

export const cardStyle = {
  backgroundColor: colors.white,
  borderRadius: '10px',
  padding: '20px',
  marginBottom: '16px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  border: `1px solid ${colors.lighterGray}`,
};

export const subheadingStyle = {
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '500',
  fontSize: '16px',
  color: colors.mediumGray,
  marginTop: 0,
};

// Button styles
export const buttonPrimary = {
  backgroundColor: '#F0CC4C',
  color: colors.nearBlack,
  padding: '14px 32px',
  borderRadius: '8px',
  border: 'none',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '600',
  fontSize: '16px',
  cursor: 'pointer',
};

export const buttonSecondary = {
  backgroundColor: 'transparent',
  color: colors.mediumGray,
  padding: '14px 32px',
  borderRadius: '8px',
  border: `1px solid ${colors.lightGray}`,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '600',
  fontSize: '16px',
  cursor: 'pointer',
};

export const buttonGold = {
  backgroundColor: colors.darkGold,
  color: colors.nearBlack,
  padding: '12px 20px',
  borderRadius: '8px',
  border: 'none',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: '600',
  fontSize: '14px',
  cursor: 'pointer',
};

export const buttonDisabled = {
  ...buttonPrimary,
  backgroundColor: colors.lightGray,
  cursor: 'not-allowed',
};

// Grid layouts
export const gridTwo = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '16px',
};

export const gridThree = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: '16px',
};

// Mobile responsive styles
export const mobileStyles = `
  @media (max-width: 600px) {
    .step-indicator-container { flex-direction: column !important; gap: 8px !important; }
    .step-indicator-container > div { margin-bottom: 4px; }
  }
`;
